define('askQuestionLoader',[
  'guidGenerator'
], () => {
  'use strict';

  /**
   * Loads the ask question module.
   * @param {*} event Event object.
   */
  function loadAskQuestionHandlerModule(event) {
    const moduleName = document.querySelector('[data-ismobiledevice="true"]')
      ? 'askQuestionMobileWrapper'
      : 'askQuestionDesktopWrapper';

    // since we're using event delegation for this event, only execute it if the target has a
    // data-askQuestionBtn attribute
    if (!event.target.closest('[data-askQuestionBtn]')) {
      return;
    }

    // remove the event listener so it doesn't fire again the load of the module
    // since the module adds another event listener and re-loading the module duplicates the event listener.
    document.removeEventListener('click', loadAskQuestionHandlerModule);

    require(
      [moduleName],
      (askQuestionHandler) => {
        askQuestionHandler.openModal(event);
      }
    );
  }

  document.addEventListener('click', loadAskQuestionHandlerModule);
});

